import { Directive, ElementRef, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { IbanFormatPipe } from 'src/app/shared/pipe/iban.format.pipe';

@Directive({
  selector: '[appIbanFormatter]',
  providers: [IbanFormatPipe]
})
export class IbanFormatterDirective {
  constructor(
    private ibanFormatPipe: IbanFormatPipe,
    @Self() private ngControl: NgControl
  ) {}

  @HostListener('input', ['$event.target'])
  onInput(inputElement: HTMLInputElement) {
    const { value, selectionStart } = inputElement;

    const rawValueBeforeCursor = value.slice(0, selectionStart).replace(/\s+/g, '').length;
    const rawValue = value.replace(/\s+/g, '');
    const formattedValue = this.ibanFormatPipe.transform(rawValue);

    let newCursorPos = 0;
    let rawCharsPassed = 0;
    while (rawCharsPassed < rawValueBeforeCursor && newCursorPos < formattedValue.length) {
      if (formattedValue[newCursorPos] !== ' ') {
        rawCharsPassed++;
      }
      newCursorPos++;
    }

    while (formattedValue[newCursorPos] === ' ' && newCursorPos < formattedValue.length) {
      newCursorPos++;
    }

    // 4. Update the form control with the raw value (without spaces).
    this.ngControl.control.setValue(formattedValue, { emitEvent: false });

    inputElement.value = formattedValue;
    inputElement.setSelectionRange(newCursorPos, newCursorPos);
  }
}
